// Module
var code = `<div class="tft-tile"> {{emailTileCtrl.email.value}} <svg class="exit-icon" ng-if="emailTileCtrl.email.canRemove" ng-click="emailTileCtrl.removeClick()"> <use xlink:href="assets/img/icons/build/svg-sprite.svg#exit"></use> </svg> </div>`;
// Exports
export default code;